import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { isMobileDevice } from 'helpers/isMobile';
import { requiredValidator, validateFields } from 'validators';
import { InputField } from 'components/FormFields/InputField';
import { ACCOUNT_FORM, accountFormAction, initializeAccountForm, watchAccountFormSagas } from '../sagas/account.saga';

const messages = defineMessages({
  firstName: {
    id: 'signup-card.account.first-name-placeholder',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'signup-card.account.last-name-placeholder',
    defaultMessage: 'Last name',
  },
});

export class AccountFormUnwrapped extends PureComponent {
  componentDidMount() {
    this.props.onMount(this.props.hiddenFields);
  }

  render() {
    const { formId, handleSubmit, intl } = this.props;

    return (
      <form className="form" id={formId} method="post" noValidate onSubmit={handleSubmit}>
        <Field
          component={InputField}
          name="firstName"
          inputAttributes={{
            placeholder: intl.formatMessage(messages.firstName),
            // Only auto focus on desktop, to prevent unwanted keyboard popup covering page content
            autoFocus: !isMobileDevice(),
          }}
        />
        <Field
          component={InputField}
          name="lastName"
          inputAttributes={{ placeholder: intl.formatMessage(messages.lastName) }}
        />
      </form>
    );
  }
}

AccountFormUnwrapped.propTypes = {
  formId: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  hiddenFields: PropTypes.object,
  intl: intlShape,
  onMount: PropTypes.func.isRequired,
};

const formConfig = {
  enableReinitialize: true,
  form: ACCOUNT_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: accountFormAction,
  onSubmitSuccess: (result, dispatch, props) => props.onSuccess(result),
  validate: validateFields(requiredValidator, ['firstName', 'lastName']),
};

export const AccountForm = decorateWith(
  withSagas({ watch: watchAccountFormSagas }),
  connect(
    null,
    { onMount: initializeAccountForm }
  ),
  injectIntl,
  reduxForm(formConfig),
  withName('AccountForm')
)(AccountFormUnwrapped);
